import React, { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { Col, Row, Container } from "react-bootstrap";
import LoadingComponent from "../components/LoadingComponent";
import { useAuth } from "../hooks/auth.hook";



function VerifyEmail() {
    const search = useLocation().search;
    const auth = useAuth();
    const history = useHistory();
    const code = new URLSearchParams(search).get('code');
    const id = new URLSearchParams(search).get('id');

    useEffect(() => {

        setTimeout(() => {
            auth.verifyEmail(code, id).then((result) => {
                console.log("result", result)
                if(result !== null && result !== undefined){
                    history.push({
                        pathname: '/login',
                        state: {  // location state
                          valid_email: true,
                          success_restart: null,
                          success_request: null,
                        }
                    })
                }else{
                    history.push({
                        pathname: '/login',
                        state: {  // location state
                          valid_email: false,
                          success_restart: null,
                          success_request: null,
                        }
                    })
                }
            })
        }, 4000)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    
    return (
        <>
            <Container>
                <Row style={{height: "100vh"}}>
                    <Col xs={12} className="d-flex align-items-center justify-content-center">
                        <div className="d-flex text-center" style={{marginBottom:"220px"}}>
                            <h2>Estamos realizando un proceso de seguridad. Una vez finalizado te redireccionaremos al inicio de sesión</h2>
                        </div>
                        
                        <LoadingComponent backgroundColor={false} className="d-flex align-items-center justify-content-center fmxw-500"></LoadingComponent>
                    </Col>
                </Row>
            </Container>
        </>
    )

}

export default VerifyEmail